export type LegacyRealtimeLearningMode = 'readonly' | 'off' | 'full';

const DEFAULT_MODE: LegacyRealtimeLearningMode = 'readonly';

export function resolveLegacyRealtimeLearningMode(raw?: string | null): LegacyRealtimeLearningMode {
  const normalized = (raw || '').trim().toLowerCase();
  if (normalized === 'full' || normalized === 'off' || normalized === 'readonly') {
    return normalized;
  }
  return DEFAULT_MODE;
}

export function getLegacyRealtimeLearningMode(): LegacyRealtimeLearningMode {
  return resolveLegacyRealtimeLearningMode(process.env.NEXT_PUBLIC_LEGACY_RT_LEARNING_MODE);
}

export function canMutateLegacyLearning(mode: LegacyRealtimeLearningMode = getLegacyRealtimeLearningMode()): boolean {
  return mode === 'full';
}

export function canLogLegacyLearning(mode: LegacyRealtimeLearningMode = getLegacyRealtimeLearningMode()): boolean {
  return mode !== 'off';
}

